'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { bindAll } from 'underscore';
import { KEYS } from 'DesignData/enums/Keys';
import ContextMenuContent from 'DesignManagerIde/components/contextMenu/ContextMenuContent';
import ContextMenuItemGroup from 'DesignData/models/ContextMenuItemGroup';

class ContextMenu extends PureComponent {
  constructor(props) {
    super(props);
    bindAll(this, ['handleKeyDown', 'handleMouseClick', 'setContentRef', 'handleContextMenuClick']);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('click', this.handleMouseClick);
    document.addEventListener('contextmenu', this.handleContextMenuClick);
  }

  componentDidUpdate() {
    if (this.props.isOpen) {
      this.setMenuCoords();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('click', this.handleMouseClick);
    document.removeEventListener('contextmenu', this.handleContextMenuClick);
  }

  setContentRef(ref) {
    this.__contentRef = ref;
  }

  setMenuCoords() {
    const {
      innerWidth,
      innerHeight
    } = window;
    const node = findDOMNode(this.__contentRef);
    const boudningRect = node.getBoundingClientRect();
    const {
      rightClickCoordX,
      rightClickCoordY,
      setContextMenuLocation
    } = this.props;
    const y = rightClickCoordY;
    let x = rightClickCoordX;
    let verticalOverflow;

    if (x + boudningRect.width > innerWidth) {
      x -= boudningRect.width;
    }

    if (y + boudningRect.height > innerHeight) {
      verticalOverflow = true;
    }

    setContextMenuLocation({
      x,
      y,
      verticalOverflow
    });
  }

  handleKeyDown(e) {
    if (e.keyCode === KEYS.ESCAPE) {
      this.props.closeContextMenu();
    }
  }

  handleMouseClick(e) {
    /* Firefox will fire a mouse click as well */
    if (e.button === 2) return;
    const domNode = findDOMNode(this);

    if (!domNode || !domNode.contains(e.target)) {
      this.props.closeContextMenu();
    }
  }

  handleContextMenuClick() {
    this.props.closeContextMenu();
  }

  render() {
    const {
      contextMenuCoordX,
      contextMenuCoordY,
      isOpen,
      contextMenuContentData,
      closeContextMenu,
      swapContextMenuContent,
      verticalOverflow
    } = this.props;
    const style = {
      left: contextMenuCoordX
    };

    if (verticalOverflow) {
      style.bottom = 0;
    } else {
      style.top = contextMenuCoordY;
    }

    const menuClasses = "context-menu " + (isOpen ? 'context-menu-active' : 'context-menu-disabled');
    return /*#__PURE__*/_jsx("div", {
      className: menuClasses,
      style: style,
      children: /*#__PURE__*/_jsx(ContextMenuContent, {
        ref: this.setContentRef,
        closeContextMenu: closeContextMenu,
        contextMenuContentData: contextMenuContentData,
        swapContextMenuContent: swapContextMenuContent
      })
    });
  }

}

ContextMenu.propTypes = {
  closeContextMenu: PropTypes.func.isRequired,
  contextMenuCoordX: PropTypes.number.isRequired,
  contextMenuCoordY: PropTypes.number.isRequired,
  verticalOverflow: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rightClickCoordX: PropTypes.number.isRequired,
  rightClickCoordY: PropTypes.number.isRequired,
  setContextMenuLocation: PropTypes.func.isRequired,
  contextMenuContentData: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.instanceOf(ContextMenuItemGroup)), PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  swapContextMenuContent: PropTypes.func.isRequired
};
export default ContextMenu;